import axios from "axios";
import { toast } from "react-hot-toast";
import { nonAuthRoutes } from "common/constants/constants";

const clearStorage = () => {
  localStorage.clear();
  if (!nonAuthRoutes.includes(window.location.pathname.toLowerCase()))
    window.location = "/";
};

axios.defaults.withCredentials = true;
axios.interceptors.request.use((request) => {
  let headers = {
    "Content-Type": "application/json",
  };
  request.headers = headers;
  return request;
});

axios.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (err) => {
    try {
      if (err?.response?.status === 401) {
        if (!["/home", "/login"].includes(window.location.pathname))
          clearStorage();
      }
    } catch (error) {
      return error?.response;
    }
    return err?.response;
  }
);
